<template>
    <div class='main'>
        <div class='plugins-tips'>
            <el-row>
                <el-col :span='22'>
                
                </el-col>
                <el-col :span='2'>
                    <el-button
                        type='primary'
                        plain
                        icon='el-icon-plus'
                        size='mini'
                        @click='handleAdd'
                    >新增事件分析
                    </el-button>
                </el-col>
            </el-row>
        </div>
        
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title='title' :visible.sync='open' width='40%' @close='cancel'>
            
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='submitForm'>保 存</el-button>
                <el-button @click='cancel'>取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { message } from '@/utils/message';
import TrackEventChart from '@view/track/analyse/component/TrackEventChart.vue';

export default {
    name: 'User',
    components: { TrackEventChart },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                appId: undefined
            }
        };
    },
    computed: {},
    watch: {},
    created() {
        this.setInitValue();
        this.initData();
    },
    beforeDestroy() {
    
    },
    methods: {
        setInitValue() {
            this.queryParams.appId = undefined;
            if (this.$route.params.appId && this.$route.params.appId.indexOf('undefined') === -1) {
                this.queryParams.appId = this.$route.params.appId;
            }
            if (!this.queryParams.appId) {
                message.error('请选择应用!');
                this.$router.push(`/storage-application`);
                return;
            }
            this.getList();
            console.log(this.queryParams.appId);
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
        
        
        },
        getList() {
            this.loading = true;
            this.loading = false;
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
            this.resetReportSetting();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                eventId: undefined,
                projectAppId: this.queryParams.projectAppId,
                name: undefined
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增事件分析';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentReportSetting = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件报表设置';
            this.setReportSettingParam(row);
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.name + '"的数据项？').then(function() {
                return trackReportSettingApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message);
                    obj.getList();
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            this.packageReportSetting(this.updateOrAddReportSetting);
        }
        
    }
};
</script>
<style lang='css'>

</style>
